import { render, staticRenderFns } from "./PublicHearingPublic.vue?vue&type=template&id=2188c804&scoped=true&"
import script from "./PublicHearingPublic.vue?vue&type=script&lang=js&"
export * from "./PublicHearingPublic.vue?vue&type=script&lang=js&"
import style0 from "./PublicHearingPublic.vue?vue&type=style&index=0&id=2188c804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188c804",
  null
  
)

export default component.exports